<template>
  <div class="render-item_image">
    <div class="render-image_label">{{labelName}}</div>
    <div class="render-image_content">
      <el-image
        v-for="(item, indexs) in currentModelProxy"
        :key="indexs"
        :preview-src-list="currentModelProxy"
        :src="currentModelProxy[indexs]"
        :show-viewer="show[indexs]"
        @close="close(indexs)"
        @open="open(indexs)"
        :index="index"
      ></el-image>
    </div>
  </div>
</template>


<script>
/** 混入方法 :::
 *  @mixin mixRenderItemTemplateChild 预览表单子级混入
 */
import { mixRenderItemTemplateChild } from "@/mixins/render_item/mix_render_item_template_child.js";

export default {
  mixins: [mixRenderItemTemplateChild],
  data() {
    return {
      index: 0,
      show: {},
    };
  },
  computed: {
    /** @name 上传图片值控制
     *  @return {Array<String>} 上传文件列表
     *  @author 王汝鹏
     *  @version 2019-12-30
     */
    currentModelProxy() {
      return Array.isArray(this.currentModel) ? this.currentModel : [];
    },
    /**
     * @name 计算点开大图弹窗绑定
     * @return { object } 计算后的对象
     * @author liuguisheng
     * @version 2020-09-15 11:18:56 星期二
     */
    showViewer: {
      get() {
        this.show = {};
        this.currentModelProxy.map((el, index) => {
          this.show[index] = false;
        });
        return this.show;
      },
      set(newValue) {
        this.show = newValue;
        this.show = { ...this.show };
      },
    },
  },
  methods: {
    /**
     * @name 打开弹窗
     * @params { Number } index 打开的索引
     * @return { void }
     * @author liuguisheng
     * @version 2020-09-15 11:19:44 星期二
     */
    open(index) {
      this.index = index;
      this.$set(this.showViewer, index, true);
    },
    /**
     * @name 关闭弹窗
     * @params { Number } index 关闭的索引
     * @return { void }
     * @author liuguisheng
     * @version 2020-09-15 11:19:44 星期二
     */
    close(index) {
      this.$set(this.show, index, false);
      this.show = { ...this.show };
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/render_item/RenderImage.vue